// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6z-0";
export var startPickingButton = "_6z-1";